// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__CHbOl","productName":"Table_productName__2w2hr"};